export default "__VITE_ASSET__DWhY1kIU__"